var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"footer-org-info",class:{
      'electron-footer-org': _vm.isElectron,
      'h5-footer-org': _vm.isH5,
      'pc-footer-org': !_vm.isH5,
    },on:{"click":function($event){return _vm.jumpUrl(`/org/${_vm.orgId}`)}}},[(_vm.orgInfo.org_logo)?_c('img',{staticClass:"logo",attrs:{"src":_vm.orgInfo.org_logo + '?imageView2/0/w/100',"alt":"logo"}}):_c('img',{staticClass:"logo",attrs:{"src":_vm.defaultOrgLogo,"alt":"logo"}}),(_vm.showOrgName)?_c('p',{staticClass:"org-name"},[_vm._v(" "+_vm._s(_vm.orgInfo.org_name)+" ")]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }